<form [formGroup]="formDetalhe">
  <div class="row">
    <div class="form-group col-md-12">
      <label>Município</label>
      <input id="municipio" formControlName="municipio"  type="text" class="form-control" >
    </div>
    <div class="form-group col-md-4">
      <label>Início Vigência<span style="color: red;">*</span></label>
      <input id="dtIni" required formControlName="dtIni" appMonthYear placeholder="MM/AAAA" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Fim  Vigência</label>
      <input id="dtFim" formControlName="dtFim" appMonthYear placeholder="MM/AAAA" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <label>Observações</label> 
      <textarea id="observacao" formControlName="observacao"  type="text" class="form-control" rows="2" maxlength="200"></textarea>      
      
    <small class="text-muted">
      {{ obsLength }} / 200
    </small>


    </div>
  </div>
</form>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirmar()">
      Salvar
    </button>
    <button type="button" class="btn btn-secondary" (click)="fechar()">
      Cancelar
    </button>
  </div>
<style>
  .aslib-grid-wrapper{
    margin-bottom: 0px !important;
  }
  .form-group {
    margin-bottom: 0.5rem !important;
  }
  </style>


// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-municipios-aptos/detalhe-muncipio/detalhe-municipio.component.html